import Frame from 'controllers/common/turbo_modal/frame';

export default class extends Frame {
  static turboFrameMarkup({ id, contentHTML }) {
    return `\
<turbo-frame
  id="${id}"
  style="width: 100%"
  data-turbo-modal-target="initialFrameContent"
>
  ${contentHTML}
</turbo-frame>
`;
  }

  onConnect() {
    this.contentParentElement.innerHTML = this.constructor.turboFrameMarkup({
      id: this.id,
      contentHTML: this.initialContentHTML,
    });
  }
}
